import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from "@air/next-icons";
import { Input } from "@air/primitive-input";
import debounce from "lodash/debounce";
import { memo, useCallback } from "react";
export const BoardSelectSearch = /*#__PURE__*/ memo((param)=>{
    let { onChange } = param;
    /**
   * ESLint complains about passing inline function, but only this version works with debounce
   */ // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedOnChange = useCallback(debounce(onChange, 300), [
        onChange
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ _jsx(Search, {
                className: "absolute left-2 top-1/2 size-6 -translate-y-1/2 text-grey-9"
            }),
            /*#__PURE__*/ _jsx(Input, {
                className: "w-full pl-10",
                onChange: (event)=>debouncedOnChange(event.target.value),
                placeholder: "Search workspace",
                size: "large",
                type: "search"
            })
        ]
    });
});
BoardSelectSearch.displayName = "BoardSelectSearch";
